//moved hard coded dates  here for now
export const CUSTOM_DATE_FORMATS = {
  LongDateWithShortMonth: "DD-MMM-yyyy",
  LongDateTime: "DD-MMM-yyyy HH:mm A",
  ShortMonthShortYear:"MMM - YY",
  ShortMonthLongYear:"MMM yyyy",
  LongMonthLongYear:"MMMM, yyyy",
  MonthDayYear: "MM/DD/yyyy",
  YearMonthDay: "YYYYMMDD",
  FullDateYearISO: "YYYY-MM-DD",
  TwelveHourTime: "hh:mm A",
  DateTime: "YYYY-MM-DDTHH:mm:ss",
};
